export default {
  subtitle: 'Las claves autentican las solicitudes a la API de Partners. Envíalas en el encabezado x-api-key.',
  never_used: 'Nunca usada',
  revoke_confirm: '¿Revocar esta clave? Las solicitudes que la usen dejarán de funcionar de inmediato.',
  columns: {
    name: 'Nombre',
    key: 'Clave',
    status: 'Estado',
    last_used_at: 'Último uso',
    created_at: 'Creada',
  },
  statuses: {
    active: 'Activa',
    revoked: 'Revocada',
  },
  buttons: {
    create: 'Crear clave',
    revoke: 'Revocar',
  },
  toasts: {
    load_error: 'No se pudieron cargar las claves de API.',
    error: 'Algo salió mal. Inténtalo de nuevo.',
    revoked: 'Clave de API revocada.',
  },
};
